var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-sidebar" }, [
    _c(
      "div",
      {
        staticClass: "sidebar",
        class: _vm.classes,
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.toggle.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "aside",
          { staticClass: "content" },
          [
            _vm._t("content"),
            _vm._v(" "),
            _c("h5", { staticClass: "mobile-copy" }, [
              _vm._v("\n        Desenvolvido por\n        "),
              _c(
                "a",
                {
                  staticClass: "kaledo",
                  attrs: {
                    target: "_blank",
                    href: "https://www.kaledo.com.br/"
                  }
                },
                [_vm._v("Kaledo")]
              ),
              _vm._v("\n        © " + _vm._s(_vm.year) + "\n      ")
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "backdrop", on: { click: _vm.toggle } }),
        _vm._v(" "),
        _c("h5", { staticClass: "copy" }, [
          _vm._v("\n      Desenvolvido por\n      "),
          _c(
            "a",
            {
              staticClass: "kaledo",
              attrs: { target: "_blank", href: "https://www.kaledo.com.br/" }
            },
            [_vm._v("Kaledo")]
          ),
          _vm._v("\n      © " + _vm._s(_vm.year) + "\n    ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a34466a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a34466a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CSidebar.vue
// module id = yNdp
// module chunks = 1624